import { type LocalApp, useApplication } from 'ApplicationContext';
import type { ReactNode } from 'react';

const AppAccess = ({ children, app }: { children: ReactNode; app: LocalApp }) => {
  const { app: currentApp } = useApplication();
  if (app === currentApp) {
    return <>{children}</>;
  }

  return null;
};

export default AppAccess;
